import type { FieldStatus, Passport, PassportField } from "../types";
import { STATUS_ORDER } from "./statusMeta";

const BLOCKS = [
  "identity",
  "primary_market",
  "secondary_market",
  "post_trade",
  "eurosystem_collateral",
] as const;

function isField(v: unknown): v is PassportField {
  return !!v && typeof v === "object" && "status" in v;
}

/** Honest coverage sentence: one source of truth for the home page,
 * the corpus page and the static block in index.html. */
export function coverageSentence(
  full: number,
  partial?: number | null,
): string {
  if (!partial)
    return `Coverage: ${full} full passports for Spanish securities. Full passports combine ESMA, ECB and GLEIF records with field-level provenance. Other ISINs are not in this set yet; search checks which public sources know them.`;
  return `Coverage: ${full} full passports and ${partial} partial records for Spanish securities. Full passports combine ESMA, ECB and GLEIF records with field-level provenance; partial records show identity and venues from isin-es (ESMA FIRDS). Other ISINs are not in this set yet; search checks which public sources know them.`;
}

export function countStatuses(p: Passport): Record<FieldStatus, number> {
  const out = Object.fromEntries(STATUS_ORDER.map((s) => [s, 0])) as Record<
    FieldStatus,
    number
  >;
  for (const b of BLOCKS)
    for (const v of Object.values(p[b])) if (isField(v)) out[v.status] += 1;
  return out;
}
